import { Injectable } from '@angular/core';
import { setting } from '@scaffold/editor/settings';
import { settings } from '@scaffold/editor/settings_list';
import { Observable, of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  /**subsritption to get the current serttings.
   * Currenlty in a static file, but will probably be moved to the server*/
  getSettings(): Observable<any> {
    return of(settings);
  }

  constructor() {}
}
